import ScannerSetup from './ScannerSetup';

export default ScannerSetup;
